import React, { useCallback, useEffect, useState } from "react";
import { LogicalOperatorEnumerator } from "./LogicalOperatorsOptions";

/**
 * Represents the AND/OR operator
 * @returns
 */
const LogicalOperatorAndOrView = ({
  isPrefixDefault,
  index,
  onSwitchBinaryOperator,
  value,
}) => {
  const [operator, setOperator] = useState(
    value || LogicalOperatorEnumerator.And
  );
  useEffect(() => {
    onSwitchBinaryOperator && onSwitchBinaryOperator(index, operator);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operator, index]);

  const switchOperator = useCallback(() => {
    switch (operator) {
      case LogicalOperatorEnumerator.And:
        setOperator(LogicalOperatorEnumerator.Or);
        break;
      case LogicalOperatorEnumerator.Or:
        setOperator(LogicalOperatorEnumerator.And);
        break;
      default:
        setOperator(LogicalOperatorEnumerator.And);
        break;
    }
  }, [operator]);
  return (
    <span className="query-element ml-1">
      <div
        className="query-binary-operator cursor-pointer"
        onClick={switchOperator}
      >
        {operator}
      </div>
      {isPrefixDefault && " by"}
    </span>
  );
};

export default LogicalOperatorAndOrView;
